const routes = {
  path: "/",
  name: "Inicio",
  component: () => import("./views/Home.vue"),
  meta: { requiresAuth: true },
};

export default routes;
